var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.23 3.56H.77a.77.77 0 0 0-.77.77v7.7a.77.77 0 0 0 .77.78H4.3v-1.43h-.72v-.7h12.86v.7h-.72v1.43h3.52a.77.77 0 0 0 .77-.77V4.33a.77.77 0 0 0-.77-.77Zm-5.3 2.13h-1.07V4.62h1.07V5.7Zm2.14 0H15V4.62h1.07V5.7Zm2.14 0h-1.07V4.62h1.07V5.7ZM15.71 0H4.3v2.85h11.4V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 17.07h10v-5.69H5v5.7Zm1.43-4.98h7.14v.72H6.43v-.72Zm0 1.43h7.14v.7H6.43v-.7Zm0 1.42h7.14v.71H6.43v-.71Z"
  })));
};
export default SvgPrinter;